import Highlight, { defaultProps } from "prism-react-renderer";
import theme from "prism-react-renderer/themes/github";
import { Pre, Line, LineNo, LineContent } from "./styles";

// Python Sample Code for Post Journal Entry Batch Light
const python = `import http.client
import json
conn = http.client.HTTPSConnection("baseurl")
payload = json.dumps([
  {
    "backofficeAccountNumber": "AAAA-AAA-988425-C",
    "transactionType": "Deposit",
    "amount": 0.01,
    "externalId": "string",
    "tradeDate": "2025-05-15T06:32:03.675Z"
  },
  {
    "backofficeAccountNumber": "AAAA-AAA-988425-PX",
    "transactionType": "Withdrawal",
    "amount": 0.01,
    "externalId": "string",
    "tradeDate": "2025-05-15T06:32:03.675Z"
  }
])
headers = {
  'Content-Type': 'application/json',
  'Authorization': 'Bearer Bearer abc'
}
conn.request("POST", "/API/JournalEntry/PostJournalEntryBatch", payload, headers)
res = conn.getresponse()
data = res.read()
print(data.decode("utf-8"))
`;

function HTTPPostJournalEntryBatchPython() {
  return (
    <Highlight {...defaultProps} theme={theme} code={python} language="python">
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <Pre className={className} style={style}>
          {tokens.map((line, i) => (
            <Line key={i} {...getLineProps({ line, key: i })}>
              <LineNo>{i + 1}</LineNo>
              <LineContent>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </LineContent>
            </Line>
          ))}
        </Pre>
      )}
    </Highlight>
  );
}
export default HTTPPostJournalEntryBatchPython;
